import React from 'react';
import Icon from 'components/icon/Icon';

const SingleCheckboxFilter = ({ filter, classModifier, isChecked, toggleFilters }) => {
    return (
        <div className={`single-checkbox-filter ${classModifier}`}>
            <div onClick={() => toggleFilters(filter, filter.values[0])}
                className={`single-checkbox-filter-item ${isChecked ? 'active' : ''}`}>
                <Icon glyph='tick' />
                <span>{filter.label}</span>
            </div>
        </div>
    );
};

SingleCheckboxFilter.PropTypes = {
    filter: React.PropTypes.object.isRequired,
    classModifier: React.PropTypes.string,
    isChecked: React.PropTypes.bool.isRequired,
    toggleFilters: React.PropTypes.func
};

export default SingleCheckboxFilter;



/** WEBPACK FOOTER **
 ** ./src/components/filtered-listing/filters/single-checkbox-filter/SingleCheckboxFilter.jsx
 **/